import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UsersThree, X } from '@phosphor-icons/react';

export const SubsPromoCard = () => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('subs_promo_dismissed') === '1');

  if (dismissed) return null;

  return (
    <div className="relative bg-neutral-900 border-2 border-black rounded-2xl p-5 shadow-[4px_4px_0px_#EA580C] mb-6 overflow-hidden" data-testid="subs-promo-card">
      <button
        onClick={() => { localStorage.setItem('subs_promo_dismissed', '1'); setDismissed(true); }}
        className="absolute top-3 right-3 text-neutral-500 hover:text-white"
        aria-label="Dismiss"
        data-testid="subs-promo-dismiss"
      >
        <X size={16} weight="bold" />
      </button>
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-xl bg-[#EA580C] flex items-center justify-center shrink-0">
          <UsersThree size={24} weight="bold" className="text-white" />
        </div>
        <div className="min-w-0">
          <p className="text-[10px] font-black uppercase tracking-widest text-[#EA580C] mb-0.5">New Feature</p>
          <h3 className="font-black text-white text-lg leading-tight mb-1">Build Your Crew of Subs</h3>
          <p className="text-sm text-neutral-400 mb-3">
            Post jobs open to licensed subcontractors, link sub jobs to parent projects, and manage your whole chain — while subbing on other projects yourself.
          </p>
          <button
            onClick={() => navigate('/post-job')}
            className="px-5 py-2 bg-[#EA580C] text-white text-sm font-black uppercase rounded-full border-2 border-black shadow-[2px_2px_0px_#000] active:translate-y-0.5 active:shadow-none"
            data-testid="subs-promo-cta"
          >
            Post a Sub-Friendly Job
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubsPromoCard;
